import { Typography } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import { useEffect, useState } from "react";
import getYearDifference from "../../../../../utils/getAgeDifference";
import Input from "../../../../common/FormComponents/Input";
import Select from "../../../../common/FormComponents/Select";
import { monthLocales } from "../../../../../constant/monthLocales";
import FormSectionHeader from "../../../../common/Form/FormSectionHeader";
import FormSectionGrid from "../../../../common/Form/FormSectionGrid";

const PersonalInfo = ({
  control,
  errors,
  pageText,
  setAge,
  lookupDropdownData,
  pastYearsList,
  DayList,
  candidateData,
  getLanguageCode,
}: any) => {
  const [day, setDay] = useState(candidateData?.day?.value || "");
  const [month, setMonth] = useState(candidateData?.month?.value || "");
  const [year, setYear] = useState(candidateData?.year?.value || "");
  let languageCode = getLanguageCode();

  useEffect(() => {
    if (year && day && month) {
      const data = `${year}-${month}-${day}`;
      const age = getYearDifference(data);
      setAge(age);
    }
  }, [year, month, day]);

  return (
    <>
      <FormSectionHeader>
        {pageText?.textMetadata?.personalInformationtext}
      </FormSectionHeader>
      <FormSectionGrid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="firstName"
            type="text"
            maxLength={30}
            control={control}
            placeholder={pageText?.validationMessages?.placeholdertext}
            placeholderPopup
            errors={errors}
            label={`${pageText?.labelsMetadata.firstNameLabel} *`}
            rules={{
              required: pageText?.validationMessages?.pleaseEnterFirstName,
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Input
            name="lastName"
            type="text"
            maxLength={30}
            control={control}
            placeholder={pageText?.validationMessages?.placeholdertext}
            placeholderPopup
            errors={errors}
            label={`${pageText?.labelsMetadata.lastNameLabel} *`}
            rules={{
              required: pageText?.validationMessages?.pleaseEnterLastName,
            }}
          />
        </Grid>
        <Grid xs={12} component={Typography} fontSize="14px">
          {pageText?.labelsMetadata.dateOfBirthLabel} *
        </Grid>
        <Grid xs={12} sm={4} className="field">
          <Select
            label={`${pageText?.labelsMetadata?.day} *`}
            classNamePrefix={"form_drop"}
            placeholder={`${pageText?.labelsMetadata?.selectText}`}
            options={DayList}
            control={control}
            errors={errors}
            name="day"
            onCustomChange={(e: any) => setDay(e.value)}
            rules={{
              required: {
                value: true,
                message: pageText?.textMetadata?.pleaseselectday,
              },
            }}
          />
        </Grid>
        <Grid xs={12} sm={4} className="field">
          <Select
            label={`${pageText?.labelsMetadata?.month} *`}
            classNamePrefix={"form_drop"}
            placeholder={`${pageText?.labelsMetadata?.selectText}`}
            options={
              languageCode.substring(0, 2) === "en"
                ? monthLocales["en-GB"]
                : monthLocales[languageCode]
            }
            control={control}
            errors={errors}
            onCustomChange={(e: any) => setMonth(e.value)}
            name="month"
            rules={{
              required: {
                value: true,
                message: pageText?.textMetadata?.pleaseselectmonth,
              },
            }}
          />
        </Grid>
        <Grid xs={12} sm={4} className="field">
          <Select
            label={`${pageText?.labelsMetadata.year} *`}
            classNamePrefix={"form_drop"}
            placeholder={`${pageText?.labelsMetadata?.selectText}`}
            options={pastYearsList}
            control={control}
            errors={errors}
            onCustomChange={(e: any) => setYear(e.value)}
            name="year"
            rules={{
              required: {
                value: true,
                message: pageText?.textMetadata?.pleaseselectyear,
              },
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Select
            label={`${pageText?.labelsMetadata.genderLabel} *`}
            classNamePrefix={"form_drop"}
            placeholder={`- ${pageText?.labelsMetadata?.selectText} -`}
            options={lookupDropdownData?.genders}
            control={control}
            errors={errors}
            name="gender"
            rules={{
              required: {
                value: true,
                message: pageText?.validationMessages?.pleaseSelectGender,
              },
            }}
          />
        </Grid>
        <Grid xs={12} sm={6} className="field">
          <Select
            label={`${pageText?.labelsMetadata.nationality} *`}
            classNamePrefix={"form_drop"}
            placeholder={`- ${pageText?.labelsMetadata?.selectText} -`}
            options={lookupDropdownData?.countries}
            control={control}
            errors={errors}
            name="nationality"
            rules={{
              required: {
                value: true,
                message: pageText?.validationMessages.pleaseSelectNationality,
              },
            }}
          />
        </Grid>
      </FormSectionGrid>
    </>
  );
};

export default PersonalInfo;
